/* eslint-disable no-console */
/* We're building a logger here, so we need to use console. */

/**
 * Enable a logger to the turbo links events
 *
 * @param {string[]?} events - specify the events to log.
 */
export function enableTurboLogger(
  events = [
    "click",
    "before-visit",
    "visit",
    "submit-start",
    "before-fetch-request",
    "before-fetch-response",
    "submit-end",
    "before-cache",
    "before-render",
    "before-stream-render",
    "load",
    "frame-render",
    "frame-load",
  ],
) {
  const mappedEvents = events.map((e) => `turbo:${e}`);

  for (const event of mappedEvents) {
    document.addEventListener(event, (e) => {
      console.debug(`TurboLogger: \`${event}\` fired\n`, e.target, e);
    });
  }

  console.debug("Started TurboLogger");
}
